export default "__VITE_ASSET__cuJmGQ4f__"